<template>
  <div class="form-group">
    <label class="font-size-12">{{ label }}</label>
    <div :id="`icon-picker-wrap_${id}`" class="icon-picker-wrap">
      <div class="icon-picker-wrapHeader">
        <template v-if="value">
          <label :data-id="id" @click="toggleBox">{{ value }}</label>
          <i :class="xMarkIcon" :data-id="id" @click="clearIcon" />
        </template>
        <template v-else>
          <label :data-id="id" @click="toggleBox"><i :class="magnifyingIcon" /></label>
        </template>
      </div>
      <div v-if="showBox" class="icon-picker-modal">
        <div class="icon-picker-modalHeader" :data-id="id">
          <input v-model="search" type="text" class="form-control" placeholder="Search icons..." :data-id="id" />
        </div>
        <ul>
          <li v-for="(icon, index) in faIcons" :key="index" :class="{ active: !search || getIconName(icon).includes(search) }" :data-id="id" @click="clickIcon(icon)">
            <i :title="icon" :class="`fa ${getIconExtra(icon)} fa-${getIconName(icon)}`" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import './Styles/IconPicker.scss'
import FontAwesomeIconsObject from './FontAwesomeIconsObject'
import { MAGNIFYING_ICON, XMARK_ICON } from '@src/icons'
export default {
  props: {
    id: { type: String, default: null, required: true },
    label: { type: String, default: '' },
    value: { type: [Number, String], default: '' }
  },
  data() {
    return {
      magnifyingIcon: MAGNIFYING_ICON,
      xMarkIcon: XMARK_ICON,
      faIcons: JSON.parse(JSON.stringify(Object.keys(FontAwesomeIconsObject))),
      showBox: false,
      search: '',
      $container: null
    }
  },
  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    addListener() {
      this.$container = document.getElementById(`icon-picker-wrap_${this.id}`)
      if (this.$container) document.body.addEventListener('click', this.manageIconPicker)
    },
    removeListener() {
      if (this.$container) document.body.removeEventListener('click', this.manageIconPicker)
    },
    manageIconPicker(e) {
      if (this.$container && this.showBox && !this.isIconPickerDescendant(e.target)) {
        this.hideBox()
      }
    },
    isIconPickerDescendant(target) {
      const dataId = target.getAttribute('data-id')
      return dataId === this.id
    },
    hideBox() {
      this.showBox = false
      this.search = ''
      this.removeListener()
    },
    toggleBox() {
      this.showBox = !this.showBox
      if (!this.showBox) {
        this.hideBox()
      } else {
        this.addListener()
      }
    },
    getIconExtra(string) {
      if (string.split(' ').length > 1 && string.split(' ')[0] && string.split(' ')[1]) {
        return string.split(' ')[0]
      }
      return ''
    },
    getIconName(string) {
      if (string.split(' ').length > 1 && string.split(' ')[0] && string.split(' ')[1]) {
        return string.split(' ')[1]
      }
      return string
    },
    clickIcon(string) {
      this.$emit('input', string)
      this.$emit('change', this)
      this.hideBox()
    },
    clearIcon() {
      this.$emit('input', '')
      this.$emit('change', this)
      this.hideBox()
    }
  }
}
</script>